export const ERROR_DISMISSED = 'ERROR_DISMISSED';

const dismissError = errorId => (
  (dispatch) => {
    dispatch({
      type: ERROR_DISMISSED,
      errorId,
    });
  }
);

export default dismissError;
